/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Add_Subject_EmptyInputs */



/**
* | output |
* | --- |
* | "Select a user or team." |
*
* @param {Rights_Add_Subject_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_add_subject_empty = /** @type {((inputs?: Rights_Add_Subject_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Add_Subject_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einen Nutzer oder ein Team auswählen.")
	return /** @type {LocalizedString} */ ("Select a user or team.")
});